import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { NetworkType } from "../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { FsaAuthorisationStatusMap, FsaAuthorisationStatusArray, errorMsg } from "../../Resource/Content";
import { NoSpecial, Email, Numeric } from "../../../../../react-core/Html/Validation/RegExPatterns";
import { NetworkInstructionModel } from "../../../../../Wrap/Models/Models/Network/NetworkInstructionModel";
import { SectionHeader } from "../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { FirmAddress } from "../../../Company/CompanyWizard/Components/CompanySetUpWizard/FirmDetail/FirmAddress";
import { ContactOwnerType } from "../../../../../Wrap/Models/Models/Instructions/ContactOwnerType";
import { CountryPhone } from "../../../Company/CompanyWizard/Components/CompanySetUpWizard/FirmDetail/CountryPhone";
import { NetworkHistoryModel } from "../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { ValidatorContents } from "../../../../Dashboard/Common/ValidatorHelper";
import { AlphanumericWithSpecialCharacters } from "../../../../../react-core/Html/Validation/RegExPatterns";

interface INetworkDetailsProps extends React.Props<NetworkDetails> {
    data: NetworkInstructionModel;
    onChange: (changes) => void;
    onRef: (ref) => void;
    isReview: boolean;
    serviceProvider: NetworkHistoryModel[];
}

interface INetworkDetailsState {
    confirmEmail: string;
}

export class NetworkDetails extends FormComponent<INetworkDetailsProps, INetworkDetailsState> {
    constructor(props: INetworkDetailsProps) {
        super(props);
        this.state = {
            confirmEmail: props.data.Email,
        };
    }

    child: any = [];

    isValid() {
        let flag = super.isValid();
        const child = this.child.concat();
        child.reverse().forEach((element) => {
            const isValid = element.isValid();
            if (!isValid) {flag = false;}
        });
        return flag;
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { data } = this.props;
        return (
            <>
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        {SectionHeader("Network details")}
                        <TextBoxEditor
                            onChange={(v) => {
                                this.props.onChange({ NetworkName: v });
                            }}
                            disabled={this.props.isReview}
                            value={data.NetworkName}
                            label={"Network name*"}
                            maxLength={50}
                            regex={{ errorMessage: ValidatorContents.AlphaNumericWithSpecialCharacters,
                                value: AlphanumericWithSpecialCharacters, }}
                            required="Please enter network name"
                        />
                        <SelectEditor
                            options={[NetworkType.Network]}
                            getText={(v) => "Network"}
                            selected={NetworkType.Network}
                            label="Network type"
                            disabled={true}
                            onChange={(v) => {}}
                        />
                        <SelectEditor
                            options={this.props.serviceProvider}
                            getText={(v) => {
                                return v.NetworkName;
                            }}
                            disabled={this.props.isReview}
                            selected={
                                data.LinkedServiceProviderId
                                    ? this.props.serviceProvider.filter(
                                          (ele) => ele.NetworkId == data.LinkedServiceProviderId
                                      )[0]
                                    : null
                            }
                            placeholder="Please select"
                            label="Linked service provider"
                            onChange={(v) => {
                                this.props.onChange({ LinkedServiceProviderId: v ? v.NetworkId : 0 });
                            }}
                        />
                        <TextBoxEditor
                            disabled={this.props.isReview}
                            onChange={(v) => {
                                this.props.onChange({ FcaTradingReference: v });
                            }}
                            value={data.FcaTradingReference}
                            label={"FCA/Trading reference: *"}
                            maxLength={8}
                            regex={{ errorMessage: "Must be numbers", value: Numeric }}
                            required="Please enter FCA/Trading reference"
                        />
                        <SelectEditor
                            disabled={this.props.isReview}
                            onChange={(v) => {
                                this.props.onChange({ FsaAuthorisationStatus: v });
                            }}
                            selected={data.FsaAuthorisationStatus}
                            label={"FCA/Trading status"}
                            getText={(v) => {
                                return FsaAuthorisationStatusMap[v];
                            }}
                            options={FsaAuthorisationStatusArray}
                            required="Please select FCA/Trading status"
                        />
                        <TextBoxEditor
                            disabled={this.props.isReview}
                            onChange={(v) => {
                                this.props.onChange({ ExternalReferenceCode: v });
                            }}
                            value={data.ExternalReferenceCode}
                            label={"External reference code:"}
                            maxLength={8}
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                        />
                        <hr />
                        {SectionHeader("Contact details")}
                        <FirmAddress
                            OwnerType={ContactOwnerType.Network}
                            notRequired={false}
                            isReview={this.props.isReview}
                            onRef={(ref) => this.child.push(ref)}
                            data={data.Address}
                            instructionId={data.Id}
                            onChange={(v) => this.props.onChange({ Address: v })}
                        />
                        <hr />
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CountryPhone
                            isReview={this.props.isReview}
                            onChange={(v) => this.props.onChange({ PhoneNumber: v })}
                            required={true}
                            isFax={false}
                            sectionHeader="Phone number"
                            data={data.PhoneNumber}
                            onRef={(ref) => this.child.push(ref)}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CountryPhone
                            isReview={this.props.isReview}
                            onChange={(v) => this.props.onChange({ FaxNumber: v })}
                            isFax={true}
                            sectionHeader="Fax number"
                            data={data.FaxNumber}
                            onRef={(ref) => this.child.push(ref)}
                        />
                        <TextBoxEditor
                            disabled={this.props.isReview}
                            label="Email address:"
                            value={data.Email}
                            regex={{
                                errorMessage: "invalid email address",
                                value: Email,
                            }}
                            onChange={(v) => this.props.onChange({ Email: v })}
                        />
                        <TextBoxEditor
                            disabled={this.props.isReview}
                            label="Confirm email address:"
                            value={this.state.confirmEmail}
                            notAllowPaste={true}
                            onChange={(v) => this.setState({ confirmEmail: v })}
                            validationRules={[
                                {
                                    errorMessage: "Must be same as email address",
                                    validator: (v) => {
                                        if (v) {
                                            return v == data.Email ? true : false;
                                        }
                                        return true;
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            </>
        );
    }
}
